import { z } from "zod";

/**
 * Zod schema for a string safe to embed in a URL path segment without encoding:
 * non-empty, alphanumeric, hyphen, and period only.
 */
export const UrlPathSegmentString = z.string().regex(/^[a-zA-Z0-9\-.]+$/, {
    message: "Must be a non-empty string of letters, digits, hyphens, and periods",
});

/** Values accepted by {@link UrlPathSegmentString}. */
export type UrlPathSegment = z.infer<typeof UrlPathSegmentString>;
